/* eslint-disable no-undef */
(function () {
  angular.module('MktzapApp.Factories')
    .factory('WaentService', WaentService)

  WaentService.$inject = ['$resource']

  function WaentService ($resource) {
    return $resource(apiUrl + '/channels/waent/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      user: { url: apiUrl + '/channels/waent/user', method: 'GET', params: {}, isArray: true },
      createActiveWaent: {
        url: apiUrl + '/channels/waent/create-active/:id',
        method: 'POST',
        params: {},
        isArray: false
      },
      getSubChannels: { url: apiUrl + '/channels/waent/sub-channels', method: 'POST', params: {}, isArray: true },
      getSubChannelsByChannelId: {
        url: apiUrl + '/channels/waent/sub-channels-by-channel-id',
        method: 'GET',
        params: {},
        isArray: true
      },
      getUserSubChannelsByChannelId: {
        url: apiUrl + '/channels/waent/user-sub-channels-by-channel-id',
        method: 'GET',
        params: {},
        isArray: true
      },
      create: { method: 'POST', params: {}, isArray: false }
    })
  }

// eslint-disable-next-line semi
})();
